import { Box } from '@mui/material';
import React, { FC, ReactNode, useEffect, useRef, useState } from 'react';

const SHADOW_HEIGHT = 10;
const FADE_DISTANCE = 200;
const MAX_OPACITY = 0.15;

const MemreScrollable: FC<{
  children: ReactNode;
  height?: string;
  sx?: any;
}> = ({ children, height = '330px', sx = {} }) => {
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const [topOpacity, setTopOpacity] = useState(0);
  const [bottomOpacity, setBottomOpacity] = useState(1);

  const handleScroll = () => {
    if (scrollRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

      setTopOpacity(Math.min(scrollTop / FADE_DISTANCE, MAX_OPACITY));
      const bottomScrollDistance = scrollHeight - clientHeight - scrollTop;
      setBottomOpacity(Math.min(bottomScrollDistance / FADE_DISTANCE, MAX_OPACITY));
    }
  };

  useEffect(() => {
    handleScroll();
  }, []);

  return (
    <Box sx={{ position: 'relative', height, ...sx }}>
      <Box
        ref={scrollRef}
        onScroll={handleScroll}
        sx={{
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        {children}
      </Box>

      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: SHADOW_HEIGHT,
          background: `linear-gradient(to bottom, rgba(0,0,0, ${topOpacity}), rgba(255,255,255, 0))`,
          pointerEvents: 'none',
          transition: 'opacity 0.3s ease',
          borderRadius: '0 0 6px 6px',
        }}
      />

      <Box
        sx={{
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          height: SHADOW_HEIGHT,
          background: `linear-gradient(to top, rgba(0,0,0, ${bottomOpacity}), rgba(255,255,255, 0))`,
          pointerEvents: 'none',
          transition: 'opacity 0.3s ease',
          borderRadius: '6px 6px 0 0',
        }}
      />
    </Box>
  );
};

export default MemreScrollable;
